import { afterEveryRender, Component, ElementRef, Inject, input, viewChild, ViewEncapsulation } from '@angular/core';
import {RdsFormFieldModule} from "@rds/angular-components";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-expandable-input',
  standalone: true,
  imports: [
    RdsFormFieldModule,
    ReactiveFormsModule
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './expandable-input.component.html',
  styleUrl: './expandable-input.component.scss'
})
export class ExpandableInputComponent {
  control = input.required<FormControl<string | null>>();
  label = input<string>("");
  dataTestId = input<string>("", {alias: 'data-testid'});
  tooltip = input<string>("");
  textFieldChild = viewChild.required<ElementRef<HTMLTextAreaElement>>('input')

  constructor(@Inject(DOCUMENT) private document: Document) {
    afterEveryRender({ write: () => {
        this.correctInputHeight();
    } }, )
  }

  correctInputHeight(){
    const textField = this.textFieldChild().nativeElement
    if (textField.scrollHeight > textField.clientHeight) {
      textField.style.height = `${4 + textField.scrollHeight}px`;
    }
    else{
      textField.style.height = `1px`;
      textField.style.height = `${4 + textField.scrollHeight}px`;
    }
  }
}
